import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ setMultipleQtyError: boolean }>;

export const DispatchSetMultipleQtyError: HandlerType = props => {
    props.dispatch({
        type: "Custom/Product/DispatchMultipleSaleQtyError",
        param: props.parameter.setMultipleQtyError,
    });
};

export const chain = [DispatchSetMultipleQtyError];

const setMultipleQtyError = createHandlerChainRunner(chain, "setMultipleQtyError");
export default setMultipleQtyError;
